import qs from 'qs';
import { AxiosInstance } from 'axios';
import { CollectionResource } from '@app/data/resources';
import { CreateCreditWalletTransactionInput } from './inputs';
import { CreditWalletResource, CreditWalletTransactionResource } from './resources';
import { CreditWalletRef, CreditWalletTransactionRef } from './refs';
import { OffsetPaginationInput } from '@app/data/inputs';

export default class CreditWallet {
    private basePath = '/api/credit-wallet';
    private http: AxiosInstance;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    // Get credit wallet associated with user
    getForUser = async (userId: ID): Promise<CreditWalletResource> => {
        const { data } = await this.http.get(`${this.basePath}/user/${userId}`);
        return data;
    };

    // Get credit wallet associated with workspace
    getForWorkspace = async (workspaceId: ID): Promise<CreditWalletResource> => {
        const { data } = await this.http.get(`${this.basePath}/workspace/${workspaceId}`);
        return data;
    };

    // Get single credit wallet
    getById = async (id: ID): Promise<CreditWalletResource> => {
        const { data } = await this.http.get(`${this.basePath}/${id}`);
        return data;
    };

    // Fetches list of credit wallet transactions
    getTransactions = async (
        id: ID,
        pagination: OffsetPaginationInput
    ): Promise<CollectionResource<CreditWalletTransactionResource, {}>> => {
        const query = qs.stringify({ ...pagination });

        const { data } = await this.http.get(`${this.basePath}/${id}/transaction?${query}`);
        return data;
    };

    // Creates and commits new transaction to wallet
    createTransaction = async (
        id: ID,
        input: CreateCreditWalletTransactionInput
    ): Promise<CreditWalletTransactionRef> => {
        const { data } = await this.http.post(`${this.basePath}/${id}/transaction`, input);
        return data;
    };
}
